import * as React from 'react';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { ApplicationType } from '../Types/Intyg.enums';
import LoadingSpinner from 'sos-common/js/components/LoadingSpinner/LoadingSpinner';
import { InputError } from 'sos-common/js/components/InputError/InputError';
import { shortuid } from 'sos-common/js/utils/guid';

export interface ISubmitButtonProps {
  isEnabled?: boolean;
}
export interface ISubmitButtonState extends FormSectionBaseState {}

export default class SubmitButton extends FormSectionBase<ISubmitButtonProps, ISubmitButtonState> {
  private _errorId;
  constructor(props: ISubmitButtonProps) {
    super(props);
    this._errorId = shortuid();
    this.state = {
      errors: this.emptyErrorsMap,
    };
  }

  static defaultProps = {
    isEnabled: true,
  };

  onSendClick = (e: React.MouseEvent) => {
    e.preventDefault();
    this.context.onClickSubmitButton(this.props.isEnabled);
  };

  public render() {
    const { Translate, applicationType, showSpinner, submitButtonIsClicked } = this.context;
    const { isEnabled } = this.props;
    const isBtnEnabled = applicationType === ApplicationType.Eservice ? isEnabled : true;
    const btnText = applicationType === ApplicationType.Eservice ? 'granskaochskickain' : 'skickain';
    let btnDisabled = !isBtnEnabled;
    if (showSpinner) {
      btnDisabled = true;
    }

    return (
      <div className="m-b-4 m-t-2">
        <div className="form-submit">
          <button className="button relative" type="submit" disabled={btnDisabled} onClick={this.onSendClick}>
            {Translate(btnText)}
            {showSpinner && <LoadingSpinner cssClasses="button-spinner" />}
          </button>
          {submitButtonIsClicked && !isEnabled && (
            <InputError id={this._errorId} errorText={Translate('error_missing_fields')} />
          )}
        </div>
      </div>
    );
  }
}
